module.exports = __webpack_public_path__ + "static/assets/4f9a17534c29f3e40970aa45d92f4ebb.png";